<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Disabled Products</span>
              </b-col>
              <!-- <b-col cols="12" md="3" class="py-2">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="sm"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="4">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="getSearch"
                        >Search</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-col> -->
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="products"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(name)="data">
              <span v-if="data.item.name.length > 50">{{
                data.item.name.slice(0, 50) + "..."
              }}</span>
              <span v-else>{{ data.item.name }}</span>
            </template>
            <template v-slot:cell(order_items)="data">
              <span>{{ data.item.order_items.length }}</span>
            </template>
            <template v-slot:cell(range)="data">
              <span v-if="data.item.range">{{ data.item.range.name }}</span>
              <span v-else>-</span>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalData"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      searchKey: null,
      products: [],
      fields: [
        { key: "itemcode", label: "Item Code", sortable: false },
        { key: "name", label: "Name", sortable: false },
        // {
        //   key: "available_quantity",
        //   label: "Available Quantity",
        //   sortable: false,
        // },
        { key: "selling_price", label: "MRP", sortable: false },
        { key: "price", label: "Selling Price", sortable: false },
        { key: "category", label: "Category", sortable: false },
      ],
      totalData: 0,
      currentPage: 1,
      perPage: 200,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      myProducts: [],
    };
  },
  beforeMount() {
    if (this.$route.query.searchKey) {
      this.searchKey = this.$route.query.searchKey;
    } else {
      this.getData();
    }
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getCategory();
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/inventory/shop/disabled",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          shop: localStorage.getItem("shopid"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data) {
            this.products = response.data.data;
            var ty = [];
            var item = {};
            for (var i = 0; i < this.products.length; i++) {
              item["itemcode"] = this.products[i].item.itemcode;
              item["name"] = this.products[i].item.name;
              item["available_quantity"] = this.products[i].available_quantity;
              item["price"] = this.products[i].price;
              item["selling_price"] = this.products[i].selling_price;
              item["category"] = this.products[i].item.category.name;
              item["category_id"] = this.products[i].item.category_id;
              item["_id"] = this.products[i]._id;
              ty.push(item);
              item = {};
            }
            this.products = ty;
          } else {
            this.products = [];
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getSearch() {
      // this.$router.push({
      //   path: "/Products",
      //   query: {
      //     searchKey: this.searchKey,
      //   },
      // });

      this.appLoading = true;
      if (!this.searchKey) {
        this.getData();
        return;
      }
      axios({
        method: "POST",
        url: "/items/by/name",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          name: this.searchKey,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data) {
            this.products = response.data.data;
            var ty = [];
            var item = {};
            for (var i = 0; i < this.products.length; i++) {
              item["itemcode"] = this.products[i].itemcode;
              item["name"] = this.products[i].name;
              item["available_quantity"] = this.products[
                i
              ].inventory.available_quantity;
              item["price"] = this.products[i].inventory.price;
              item["selling_price"] = this.products[i].inventory.selling_price;
              item["category"] = this.products[i].category.name;
              item["category_id"] = this.products[i].category_id;
              item["_id"] = this.products[i].inventory._id;
              ty.push(item);
              item = {};
            }
            this.products = ty;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },

    // changeStylRoute(item) {
    //   this.$router.push({
    //     path: "/Products",
    //     query: {
    //       styl: this.$route.query.styl != item._id ? item._id : null,
    //       category: this.$route.query.category,
    //       subcategory: this.$route.query.subcategory,
    //       searchKey: this.$route.query.searchKey,
    //     },
    //   });
    // },
    rowClicked(item) {
      this.$router.push("/Inventory/" + item.category_id + "/" + item._id);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
